import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import FormControl from '@mui/material/FormControl';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent } from '@mui/material';
import { SlideTransition } from '../../components/Transition/Transition';
import { Preferences } from '@capacitor/preferences';

const ChooseDefaultCalendarDialog = ({ intl, open, onClose }) => {
  const [defaultCalendar, setDefaultCalendar] = useState('');

  useEffect(() => {
    const fetchDefaultCalendar = async () => {
      let { value } = await Preferences.get({ key: 'defaultCalendar' });
      setDefaultCalendar(value);
    };

    fetchDefaultCalendar();
  }, []);

  async function changeDefaultCalendar(event) {
    setDefaultCalendar(event.target.value);
    await Preferences.set({ key: 'defaultCalendar', value: event.target.value });
  }

  function closeDialog() {
    if (defaultCalendar) {
      onClose();
    }
  }

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth slots={{
      transition: SlideTransition
    }}>
      <DialogTitle id="alert-dialog-slide-title">{intl.formatMessage({ id: 'default-calendar' })}</DialogTitle>
      <DialogContent>
        <FormControl
          className="d-flex-box"
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <RadioGroup
            aria-label="inputGroupOption"
            name="defaultCalendar"
            value={defaultCalendar}
            onChange={changeDefaultCalendar}
          >
            <FormControlLabel
              value="apple-calendar"
              control={<Radio color="primary" />}
              label={intl.formatMessage({ id: 'apple-calendar' })}
            />
            <FormControlLabel
              value="google-calendar"
              control={<Radio color="primary" />}
              label={intl.formatMessage({ id: 'google-calendar' })}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} disabled={!defaultCalendar} color="primary">
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(ChooseDefaultCalendarDialog);
